import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleError } from "../../utils/toast";

//search single statstics
export const ViewStatistics = createAsyncThunk(
  "statstics",
  async (thunkAPI) => {
    try {
      let response = await axios.get(`${BaseUrl}backend-api/statstics`);
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError("loading...");
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
